// Sticky ATC
setTimeout(function () {
  var stcBtn = document.querySelector('.shopify-section--main-product .buy-buttons');
  if (stcBtn) {
    var stop = (stcBtn.offsetTop - 80);

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      stcBtn.classList.add('stick');
    }
  }
}, 500);

 function blackoutDays(date) {
        var day = date.getDay();
        var today = new Date();
        var blockDate = new Date(today.setDate(today.getDate() + 2));
        // Block today and the next two days
        if (date <= blockDate) {
            return [false, "", "Unavailable"];
        }
        // Allow only Weekdays + Saturday (1-6) 
        return [(day == 1 ||day == 2 ||day == 3 || day == 4 ||day == 5 || day == 6), ""];
    };

  function adjustDate(selectedDate) {
    // Parse the selected date from jQuery date picker (assuming "dd.mm.yyyy" format)
    var parts = selectedDate.split(".");
    var date = new Date(parts[2], parts[1] - 1, parts[0]); // Year, Month (0-indexed), Day

    // Subtract 2 days from the selected date
    date.setDate(date.getDate() - 3);

    // Format the new date (minus 3 days) back to "dd.mm.yyyy"
    var day = ("0" + date.getDate()).slice(-2);
    var month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are 0-indexed
    var year = date.getFullYear();
    return day + "." + month + "." + year;
  }

document.addEventListener("DOMContentLoaded", function() {
  // Ensure the custom element is registered
  const DialogElementClass = window.customElements.get("dialog-element");
  
  if (DialogElementClass) {
    DialogElementClass.prototype.hideForOutsideClickTarget = function(target) {
      // Check if the target is within the date picker
      if (target.closest(".ui-datepicker")) {
        return false; // Do not close if the click is within the date picker
      }
      return !this.contains(target);
    };
  } else {
    console.error("DialogElement is not registered.");
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Retrieve the delivery date from localStorage
  let storedDate = localStorage.getItem('firstDeliveryDate');

  // If the date isn't in localStorage, calculate and store it in dd.mm.yyyy format
  if (!storedDate) {
    let date = new Date();
    date.setDate(date.getDate() + 3);
    let dayOfWeek = date.getDay();
    date.setDate(date.getDate() + (dayOfWeek <= 3 ? 3 - dayOfWeek : 6 - dayOfWeek));

    // Format the date to 'dd.mm.yyyy' and store it
    let formattedDate = date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    localStorage.setItem('firstDeliveryDate', formattedDate);
    storedDate = formattedDate;
  }

  // Function to set delivery date values in hidden input fields if they exist
  function setDeliveryDateNote() {
    const deliveryDateNoteDrawer = document.getElementById('delivery_date_note-drawer');
    const deliveryDateNote = document.getElementById('delivery_date_note');

    if (deliveryDateNoteDrawer) {
      deliveryDateNoteDrawer.value = storedDate;
    }
    if (deliveryDateNote) {
      deliveryDateNote.value = storedDate;
    }
  }

  // Function to toggle the visibility of delivery date elements on the cart page
  function toggleDeliveryDate(container, elementClass, optionSelector) {
    if (!container) return;

    const deliveryDateElements = container.querySelectorAll(elementClass);
    const option = container.querySelector(optionSelector);

    deliveryDateElements.forEach(function(deliveryDateElement) {
      if (option && option.checked) {
        deliveryDateElement.style.display = "block";
        setDeliveryDateNote();
      } else {
        deliveryDateElement.style.display = "none";
      }
    });
  }

  // Initial load and option change handling for the cart page
  const cartPage = document.getElementById('cart-page');
  if (cartPage) {
    document.querySelectorAll('input[name="custom-option-page"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        toggleDeliveryDate(cartPage, '.delivery-date', 'input[name="custom-option-page"][value="Option 2"]');
      });
    });
    toggleDeliveryDate(cartPage, '.delivery-date', 'input[name="custom-option-page"][value="Option 2"]');
  }

  // Drawer toggle setup
  function setupDatePickerToggle() {
    const radioButtons = document.querySelectorAll('input[name="custom-option-drawer"]');
    const deliveryDateDiv = document.querySelector('.delivery-date');

    if (radioButtons.length > 0) {
      function toggleDatePicker() {
        if (document.querySelector('input[name="custom-option-drawer"]:checked').value === "Option 2") {
          deliveryDateDiv.style.display = "block";
          setDeliveryDateNote();
        } else {
          deliveryDateDiv.style.display = "none";
        }
      }

      radioButtons.forEach(function(radio) {
        radio.addEventListener('change', toggleDatePicker);
      });
      toggleDatePicker();
    }
  }

  setupDatePickerToggle();
});
